export const BRACKET_MAX_PLAYERS_OPTIONS = [8, 16, 32, 64, 128, 256, 512];
export const BRACKET_SIZES = [4, ...BRACKET_MAX_PLAYERS_OPTIONS];
export const MAX_BRACKET_SIZE = 512;

export function getBracketSize(playerCount, maxBracketSize = MAX_BRACKET_SIZE) {
  const count = Number(playerCount || 0);
  const cappedMax = BRACKET_SIZES.includes(Number(maxBracketSize))
    ? Number(maxBracketSize)
    : MAX_BRACKET_SIZE;

  for (const size of BRACKET_SIZES) {
    if (size > cappedMax) break;
    if (count <= size) return size;
  }

  return cappedMax;
}

export function getTournamentTotalRounds(bracketSize) {
  const size = getBracketSize(bracketSize);
  return Math.max(1, Math.log2(size));
}

export function isSpecialCupTournament(tournament = {}, tournamentId = "") {
  const id = String(tournamentId || tournament?.id || tournament?.tournamentId || "");
  return (
    id.endsWith("_special") ||
    String(tournament?.tournamentId || "").toLowerCase() === "special"
  );
}

export function isThirdPlaceEnabledTournament(tournament = {}, tournamentId = "") {
  if (tournament?.thirdPlaceEnabled === true) return true;
  if (tournament?.thirdPlaceEnabled === false) return false;
  if (isSpecialCupTournament(tournament, tournamentId)) return true;
  return false;
}

export function isValidBracketSize(size, { includeMinimumFour = false } = {}) {
  const allowed = includeMinimumFour ? BRACKET_SIZES : BRACKET_MAX_PLAYERS_OPTIONS;
  return allowed.includes(Number(size));
}

export function getNextMatchPosition(matchIndex) {
  const index = Number(matchIndex || 0);
  return {
    nextIndex: Math.floor(index / 2),
    slot: index % 2 === 0 ? "player1Uid" : "player2Uid",
    otherSlot: index % 2 === 0 ? "player2Uid" : "player1Uid",
  };
}
